<template>
  <div class="section-care-faq section-care-faq-wrapper">
    <div class="section-care-faq-container">
      <div class="text-title-care-faq">{{ $t('faq.common.faq') }}</div>
      <div class="qa-list">
        <care-faq-item :question-desc="$t('faq.care.question1')">
          <template v-slot:answer>
            <i18n path="faq.care.answer1" tag="div" for="answer1">
              <a href="https://my.lollipop.camera/subscription2/overview?utm_source=official_website&utm_medium=page_care&utm_content=faq_start_trial_1" target="_blank">
                {{ $t('faq.care.ans1LinkText') }}
              </a>
            </i18n>
          </template>
        </care-faq-item>
        <div class="divider"></div>
        <care-faq-item :question-desc="$t('faq.care.question2')">
          <template v-slot:answer>
            <i18n path="faq.care.answer2" tag="div" for="answer2">
              <a href="https://my.lollipop.camera/subscription2/overview?utm_source=official_website&utm_medium=page_care&utm_content=faq_start_trial_2" target="_blank">
                {{ $t('faq.care.ans2LinkText') }}
              </a>
            </i18n>
          </template>
        </care-faq-item>
        <div class="divider"></div>
        <care-faq-item :question-desc="$t('faq.care.question3')">
          <template v-slot:answer>
            <i18n path="faq.care.answer3" tag="div" for="lollipopAccount">
              <a href="https://my.lollipop.camera/login/?utm_source=official_website&utm_medium=page_care&utm_content=faq_get_plan" target="_blank">
                {{ $t('faq.common.lollipopAccount') }}
              </a>
            </i18n>
          </template>
        </care-faq-item>
        <div class="divider"></div>
        <care-faq-item :question-desc="$t('faq.care.question4')">
          <template v-slot:answer>
            <i18n path="faq.care.answer4" tag="div" for="lollipopAccount">
              <a href="https://my.lollipop.camera/subscription2/overview?utm_source=official_website&utm_medium=page_care&utm_content=faq_start_trial_4" target="_blank">
                {{ $t('faq.care.ans4TextFreeTrial') }}
              </a>
              <a href="https://my.lollipop.camera/login/?utm_source=official_website&utm_medium=page_care&utm_content=faq_start_trial" target="_blank">
                {{ $t('faq.common.lollipopAccount') }}
              </a>
            </i18n>
          </template>
        </care-faq-item>
        <div class="divider"></div>
        <care-faq-item :question-desc="$t('faq.care.question5')">
          <template v-slot:answer>
            <div>{{ $t('faq.care.answer5') }}</div>
          </template>
        </care-faq-item>
        <div class="divider"></div>
        <care-faq-item :question-desc="$t('faq.care.question6')">
          <template v-slot:answer>
            <i18n path="faq.care.answer6_1" tag="div" for="lollipopAccount">
              <a href="https://my.lollipop.camera/login/?utm_source=official_website&utm_medium=page_care&utm_content=faq_unsubscribe" target="_blank">
                {{ $t('faq.common.lollipopAccount') }}
              </a>
            </i18n>
            <br>
            <div>{{ $t('faq.care.answer6_2') }}</div>
          </template>
        </care-faq-item>
        <div class="divider"></div>
        <care-faq-item :question-desc="$t('faq.care.question7')" class="last-child">
          <template v-slot:answer>
            <div>{{ $t('faq.care.answer7') }}</div>
          </template>
        </care-faq-item>
      </div>
    </div>
  </div>
</template>
<script>
import CareFaqItem from './CareFaqItem.vue';

export default {
  name: 'care-faq',
  components: {
    CareFaqItem,
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.divider
  width: 100%
  height: 1px
  background-color: #EDEDED

.clickable
  color: $btn-text-content-color
  cursor: pointer

.section-care-faq-wrapper
  padding: 80px 0
  .section-care-faq-container
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    .text-title-care-faq
      width: 90vw
      font-size: 36px
      line-height: 1.2
      font-weight: 400
    .qa-list
      width: 70vw
      margin: 60px 0 0 60px

@media screen and (min-width: 1600px)
  .section-care-faq-wrapper
    .section-care-faq-container
      .text-title-care-faq
        font-size: 40px

@media screen and (max-width: 768px)
  .section-care-faq-wrapper
    .section-care-faq-container
      .text-title-care-faq
        font-size: 32px
      .qa-list
        width: 75vw
        margin: 16px 0 0 16px

@media screen and (max-width: 576px)
  .section-care-faq-wrapper
    padding: 60px 0
    .section-care-faq-container
      .text-title-care-faq
        font-size: 28px

@media screen and (max-width: 414px)
  .section-care-faq-wrapper
    padding: 32px 0
    .section-care-faq-container
      .text-title-care-faq
        width: 80vw
      .qa-list
        margin: 8px 0 0 8px

</style>
